export default class LocalizationMock {
    static get(query) {
        if (query.length > 0) {
            //   console.log(query)
        }
       console.log(LocalizationMock.plResponse())
        return LocalizationMock.plResponse()
    }
    static plResponse() {
        return {'data': {
                'Localization': {
                    'keys': {
                        'appname': 'Autyzm App',
                        'menutitle': 'Autyzm',
                        'autismmenu0': 'Informacje podstawowe',
                        'autismmenu1': 'Autyzm - Informacje podstawowe ',
                        'autismmenu2': 'Co to jest autyzm?',
                        'autismmenu3': 'Objawy',
                        'autismmenu4': 'Krok po kroku – od diagnozy po terapię',
                        'autismmenu5': 'Kalendarz wydarzeń ',
                        'autismmenu6': 'Świat nauki ',
                        'autismmenu7': 'Autyzm ',
                        'autismmenu8': 'Medycyna ',
                        'autismmenu9': 'Psychologia',
                        'autismmenu10': 'Rehabilitacja ',
                        'autismmenu11': 'Terapie wspomagające  ',
                        'autismmenu12': 'Funkcjonowanie społeczne  ',
                        'autismmenu13': 'Dla rodziców ',
                        'autismmenu14': 'Dla nauczycieli i terapeutów  ',
                        'autismmenu15': 'Oceń swój stan zdrowia  ',
                        'autismmenu16': 'Dla rodziców ',
                        'autismmenu17': 'Dla nauczycieli i terapeutów ',
                        'autismmenu18': 'Mapa instytucji wspierających ',
                        'autismmenu20': 'Mapa instytucji ',
                        'autismmenu19': 'Kontakt ',
                        'a1': 'Autyzm – ogólnie',
                        'a2': 'Skąd wziął się ten autyzm?',
                        'a3': 'Epidemiologia ASD',
                        'a4': 'Kryteria diagnostyczne ASD',
                        'a5': 'Przyczyny zaburzeń autystycznych',
                        'a6': 'Rozwój dzieci z autyzmem ',
                        'a7': 'Funkcjonowanie',
/*                        'a7': 'Funkcjonowanie osób z ASD',*/
                        'a8': 'Funkcjonowanie dziecka ze spektrum autyzmu ',
                        'a9': 'Komunikacja osób z zaburzeniami ze spektrum autyzmu',
                        'a10': 'Rozwój społeczny osób z ASD',
                        'a11': 'Aktywności i zainteresowania ',
                        'a12': 'Edukacja',
                        /*'a12': 'Edukacja osób z ASD',*/
                        'a13': 'Uczeń z autyzmem w systemie edukacji',
                        'a14': 'Adaptacja ucznia z autyzmem w szkole',
                        'a15': 'Funkcjonowanie dziecka w grupie integracyjnej',
                        'a16': 'Rola nauczyciela wspomagającego',
                        'a17': 'Organizacja środowiska szkolnego',
                        'a18': 'Tworzenie IPETu',
                        'a19': 'Indywidualny program nauczania',
                        'a20': 'Wypalenie zawodowe nauczycieli ',
                        'a21': 'Rehabilitacja',
                                                /*'a21': 'Rehabilitacja osób z ASD',*/
                        'a22': 'Rehabilitacja wprowadzenie',
                        'a23': 'Formy terapii dzieci z autyzmem ',
                        'a24': 'Rola rodziny',
                       /* 'a24': 'Rodziny osób z ASD',*/
                        'a25': 'Informacje ogólne',
                        'a26': 'Wsparcie całej rodziny dziecka autystycznego',
                        'a27': 'Rola matki w życiu dziecka niepełnosprawnego',
                        'a28': 'Jakość życia rodzin osób niepełnosprawnych',
                        'a29': 'Rodzice a trudne zachowania dziecka z ASD ',
                        'a30': 'Oceń swój stan zdrowia',
                        'a31': 'Dla rodzin osób z ASD',
                        'a32': 'Dla osób pracujących z osobami z ASD',
                        'form_result':'Wynik: '

                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/static/api/mock/LocalizationMock.js